class Carousel {
  constructor(id) {
    this.slide = document.querySelector(`[data-slide="${id}"]`);
    this.active = 0;
    this.init();
  }

  activeSlide(index) {
    this.active = parseInt(index);
    this.items.forEach(item => jQuery(item).removeClass('active'));
    jQuery(this.items[index]).addClass('active').fadeOut(0).fadeIn(1500);
    this.thumbItems.forEach(item => item.classList.remove('active'));
    this.thumbItems[index].classList.add('active');
    this.autoSlide();
  }

  prev() {
    if (this.active > 0) {
      this.activeSlide(this.active - 1);
    } else {
      this.activeSlide(this.items.length - 1);
    }
  }

  next() {
    if (this.active < this.items.length - 1) {
      this.activeSlide(this.active + 1);
    } else {
      this.activeSlide(0);
    }
  }

  addThumbItems() { 
    let itemNo = 0;
    this.items.forEach(() => {
      this.thumb.innerHTML += `<span class="slide-thumb-items" id="${itemNo}"></span>`;
      itemNo++;
    });
    this.thumbItems = Array.from(this.thumb.children);
  }

  autoSlide() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this.next, 5000);
  }

  addNavigation() {
    const self = this;
    jQuery('.slide-thumb-items').click(function(){
      const jumpedSpanID = parseInt(jQuery(this).attr('id'));
      if ( jumpedSpanID !== self.active ){
        self.activeSlide(jumpedSpanID);
      }
    });
  }

  init() {
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.items = this.slide.querySelectorAll('.slide-items > *');
    this.thumb = this.slide.querySelector('.slide-thumb');
    this.addThumbItems();
    this.activeSlide(0);
    this.addNavigation();
  }
}

export default Carousel;